import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getWorkExperience,
  getQualifications,
  getSingleData,
  getAllQualification,
} from "../api/applicantApi";
import { RouteResponse } from "../types/index";
import apiCall from "../utils/apiCall";

const getAllRoute = async (): Promise<RouteResponse> => {
  return (await apiCall().get("/Routes/GetAllRoute")).data;
};

export const FetchData = (apiCall: any) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["applicant"],
    queryFn: apiCall,
  });
  return { data, isLoading, isError, error };
};

export const FetchWorkExperience = (applicationId: string) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["workExperience"],
    queryFn: async () => await getWorkExperience(applicationId),
  });

  return { data, isLoading, isError, error };
};

export const FetchQualifications = (applicationId: string) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["qalifications"],
    queryFn: async () => await getQualifications(applicationId),
    select: (data) => data,
  });

  return { data, isLoading, isError, error };
};

export const FetchSingleData = (
  name: string,
  url: string,
  method: string = "GET",
  body: any = {},
  config: any = { "Content-type": "application/json" }
) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [`${name}`],
    queryFn: async () => await getSingleData(url, method, body, config),
    select: (data) => data,
  });

  return { data, isLoading, isError, error };
};

export function FetchAllRoutes() {
  return useQuery(["get-all-route"], getAllRoute, {
    retry: 0,
    keepPreviousData: true,
    enabled: true,
  });
}

export function reOrderFetchedData(
  arrayInput: { RouteName: string; RouteId: number }[]
) {
  if (!arrayInput) return [];
  const sortedList = arrayInput.sort((a, b) =>
    a.RouteName.localeCompare(b.RouteName)
  );
  return sortedList;
}

export const filterRouteName = (
  input: number,
  allRoutes: { RouteName: string; RouteId: number }[]
) => {
  if (!input || !allRoutes || allRoutes.length < 1 || input == 0) return "N/A";
  const result = allRoutes.filter(
    (item: { RouteId: number; RouteName: string }) => item.RouteId == input
  )[0]?.RouteName;
  return result;
};
